import React, { Component } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';

import moment from 'moment';

import DatePicker, { registerLocale } from 'react-datepicker';
import { SimpleFetch, store } from '../../../../_helpers';

import ptBR from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBR);

const createOption = (label) => ({
  label,
  dischargeInArray: label,
});

class TriggerBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      domain: store.getState().changeDomainReducer.selectedDomain.domain_uuid,
      positionX: 0,
      positionY: 0,
      regularExpression: false,
      valueFilter: "0",
      valueComparation: '==',
      value: '',
      dischargeInArray: [],
      dischargeInValue: "",
      dischargeIn: [],
      tooltipIsOpen: false,

      eventAvailableParentCategories: [],
      eventParentCategory: "",
      eventParentCategoryValue: "",
      eventAvailableKeys: [],
      eventKey: "",
      eventAvailableValues: [],
      eventValues: [],
      eventComparation: "",

      pageviewValue: ""
    }

    this.handleEventComparationChange = this.handleEventComparationChange.bind(this);

    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleChangeComparation = this.handleChangeComparation.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.handleChangeRegularExpression = this.handleChangeRegularExpression.bind(this);

    this.handleChangeDischarge = this.handleChangeDischarge.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.handleEventParentCategorySelect = this.handleEventParentCategorySelect.bind(this);
    this.handleEventKeySelect = this.handleEventKeySelect.bind(this);
    this.handleEventValueSelect = this.handleEventValueSelect.bind(this);

    this.handlePageviewValue = this.handlePageviewValue.bind(this);
  }

  componentWillMount() {
    const cardData = this.props.cardData
    
    if (cardData) {
      let arrValues = cardData.values[0].dischargeIn ? cardData.values[0].dischargeIn.split(',') : [];

      arrValues = arrValues.map((element) => {
        return createOption(element)
      })

      this.setState({
        valueFilter: cardData.values[0].filter,
        valueComparation: cardData.values[0].comparation,
        value: cardData.values[0].value,
        regularExpression: cardData.regex,
        dischargeIn: cardData.values[0].dischargeIn,
        dischargeInArray: arrValues
      });
    }
  }

  componentDidMount() {
    if (this.props.viewMode) return this.setState({viewMode: true});
  }

  handleChangeRegularExpression(e) {
    this.setState({regularExpression: e.target.checked});
  }

  async handleChangeFilter(e) {
    let val = e.target.value;

    if ( val !== 'pageview' ) {
      if ( val === "events" || val === "abandon" ) {
        const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/event/${this.state.domain}`);
        if ( req.status !== 200 ) {
          return toast.error("Ocorreu um erro ao listar os eventos disponíveis. Tente novamente mais tarde.", { position: toast.POSITION.TOP_RIGHT, className: 'toast-error' });
        }

        return this.setState({
          changedTrigger: true,
          valueFilter: val,
          eventAvailableParentCategories: req.data.map(a => {return {label: a.parent_category, value: a.uuid}})
        })
      }

      return this.setState({
        changedTrigger: true,
        valueFilter: val,
        regularExpression: false
      })
    }

    this.setState({
      changedTrigger: true,
      valueFilter: val
    });
  }

  handleChangeComparation(e) {
    this.setState({
      valueComparation: e.target.value
    });
  }

  handleChangeValue(e) {
    this.setState({
      value: e.target.value
    });
  }

  handleChangeDischarge(e, dischargeInArray) {
    if ( dischargeInArray.action === 'remove-value' ) {
      let newDischargeInArray = [...this.state.dischargeInArray];

      newDischargeInArray = newDischargeInArray.filter(element => {
        return element.dischargeInArray !== dischargeInArray.removedValue.dischargeInArray
      })

      this.setState({dischargeInArray: newDischargeInArray});
    } else {
      this.setState({dischargeInArray: []});
    }
  }

  handleInputChange(dischargeInValue) {
    this.setState({ dischargeInValue });
  }

  handleKeyDown(e) {
    const { dischargeInValue, dischargeInArray, dischargeIn } = this.state;

    if (!dischargeInValue) return;

    let key = e.key;

    if (e.nativeEvent.type === 'blur')
      key = 'blur';

    switch (key) {
      case ';':
      case 'Enter':
      case 'Tab':
      case 'blur':
        let arr = [];
        arr.push(dischargeInValue);

        this.setState({
          dischargeInValue: '',
          dischargeInArray: [...dischargeInArray, createOption(dischargeInValue)],
        });

        dischargeInArray.map(items => {
          arr.push(items.dischargeInArray);
        });

        arr.sort((a, b) => a - b);

        let dischargeInValues = dischargeInValue.split(' ');
        let resultado = 0;
        let resultados = !this.state.dischargeIn ? [] : this.state.dischargeIn;
        dischargeInValues.map(async values => {
          let multipliers = {
            "A": 31536000,
            "M": 2592000,
            "D": 86400,
            "h": 3600,
            "m": 60,
            "s": 1
          }

          let regex = values.match(/[a-z]+|[^a-z]+/gi);
          let value = regex[0];
          let multiplier = multipliers[regex[1]];
          let totalSeconds = multiplier * value;

          if ( !multiplier ) multiplier = "Não foi possível definir um valor. Reescreva seu intervalo.";

          resultado = resultado + totalSeconds;
        })

        if ( isNaN(resultado) ) return;

        resultados.push(resultado);
        this.setState({dischargeIn: resultados});

        e.preventDefault();
        break;
      default:
       break;
    }
  };

  async handleEventParentCategorySelect(e, ignoreReq) {
    if ( !ignoreReq ) {
      const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/event/filters/${e.value}`);
      if ( req.status !== 200 ) {
        return toast.error("Ocorreu um erro ao listar as chaves disponíveis. Tente novamente mais tarde.", { position: toast.POSITION.TOP_RIGHT, className: 'toast-error' });
      }

      return this.setState({
        eventParentCategory: e.label,
        eventParentCategoryValue: e.value,
        eventAvailableKeys: req.data.map(a => {return {label: a, value: a}})
      });
    }

    if ( !e ) return;
    this.setState({eventParentCategory: e.label});
  }

  async handleEventKeySelect(e) {
    const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/event/filters/${this.state.eventParentCategoryValue}/key/${e.value}`);
    if ( req.status !== 200 ) {
      return toast.error("Ocorreu um erro ao listar os valores disponíveis. Tente novamente mais tarde.", { position: toast.POSITION.TOP_RIGHT, className: 'toast-error' });
    }

    this.setState({
      eventKey: e.value,
      eventAvailableValues: req.data.map(a => {return {label: a, value: a}})
    });
  }

  handleEventComparationChange(e) {
    this.setState({eventComparation: e.value});
  }

  handleEventValueSelect(e) {
    let eventValues = e.map(a => a.value);
    this.setState({eventValues});
  }

  handlePageviewValue(e, bool) {
    let arr = [];
    
    if ( !e || e.length === 0 ) return
    e.map((values) => arr.push(values.value));

    this.setState({pageviewValue: arr.join(',')});
  }

  render() {
    const { tooltipIsOpen } = this.state;

    return(
      <div className="block trigger-block trigger-block-component">
        <input type="hidden" name="trigger-type" id="trigger-type" defaultValue="trigger"/>

        <div className="custom-tooltip">
          <a href="#" className={`custom-tooltip-link ${tooltipIsOpen ? 'active' : ''}`} onClick={() => tooltipIsOpen ? this.setState({tooltipIsOpen: false}) : this.setState({tooltipIsOpen: true})}>
            <span>?</span>
            
            <div className="custom-tooltip-card">
              <p>Melhor momento para notificar os clientes. Exemplo: Visualizações de determinada página e até mesmo a Recorrência.</p>
            </div>
          </a>
        </div>

        <p className="block-title">Gatilho</p>
        <div className="select-group">
          <select name="trigger-filter" id="trigger-filter" className="form-control" value={this.state.valueFilter} onChange={this.handleChangeFilter} required disabled={this.state.viewMode}>
            <option value="0" disabled>Selecione uma opção</option>
            <option value="pageview">Visualização da Página</option>
            {/* <option value="conversion">Conversão</option>
            <option value="recurrence">Recorrência</option> */}
            <option value="events">Evento</option>
            <option value="abandon">Abandono</option>
          </select>
        </div>

        <br/>

        {
          this.state.valueFilter !== "0" ?
            <div className='filter-group active'>
              {
                this.state.valueFilter !== "recurrence" ?
                  this.state.valueFilter === 'pageview' ?
                    <span>
                      <p className="block-title">Filtrar por:</p>
                      <div className="select-group">
                        <select name="trigger-comparation" id="trigger-comparation" className="form-control" value={this.state.valueComparation} onChange={this.handleChangeComparation} required disabled={this.state.viewMode}>
                          <option value="==">Igual a</option>
                          <option value="!=">Diferente de</option>
                          <option value="contain">Contém</option>
                          <option value="notcontain">Não contém</option>
                        </select>
                      </div><br/>
                      <input type="hidden" name="trigger-value" id="trigger-value" value={this.state.pageviewValue}/>
                      <CreatableSelect
                        className="basic-select"
                        isClearable
                        isMulti
                        onChange={(e) => this.handlePageviewValue(e, true)}
                        placeholder="Insira os valores"
                        isDisabled={this.state.viewMode}
                      />
                    </span>

                  : <span>
                      {
                        this.state.valueFilter === "abandon" ?
                          <>
                            <p className="block-title">1ª Condição:</p>
                            <input type="hidden" id="trigger-comparation" name="trigger-comparation" value="contain"/>
                            <Select
                              options={[
                                {label: "Contém", value: "contain"},
                              ]}
                              className="basic-select"
                              classNamePrefix="select"
                              placeholder="Selecione o valor"
                              onChange={this.handleEventComparationChange}
                              defaultValue={{label: "Contém", value: "contain"}}
                              isDisabled
                            /><br/>

                            <p className="block-title">1º Valor:</p>
                            <input type="hidden" id="trigger-parentCategory" name="trigger-parentCategory" value={this.state.eventParentCategory}/>
                            <CreatableSelect
                              className="basic-select"
                              options={this.state.eventAvailableParentCategories}
                              isClearable
                              onChange={(e) => this.handleEventParentCategorySelect(e, true)}
                              placeholder="Selecione ou insira"
                              isDisabled={this.state.viewMode}
                            /><br/>
                            
                            <p className="block-title">2ª Condição:</p>
                            <input type="hidden" id="trigger-comparation" name="trigger-comparation2" value={this.state.eventComparation}/>
                            <Select
                              options={[
                                {label: "Não contém", value: "notcontain"},
                                {label: "Contém", value: "contain"}
                              ]}
                              className="basic-select"
                              classNamePrefix="select"
                              placeholder="Selecione o valor"
                              onChange={this.handleEventComparationChange}
                            /><br/>

                            <p className="block-title">2º Valor:</p>
                            <input type="hidden" id="trigger-parentCategory" name="trigger-parentCategory2" value={this.state.eventParentCategory2}/>
                            <Select
                              options={this.state.eventAvailableParentCategories}
                              className="basic-select"
                              classNamePrefix="select"
                              placeholder="Selecione o valor"
                              onChange={(e) => this.setState({eventParentCategory2: e.label})}
                              isDisabled={this.state.viewMode}
                            /><br/>
                          </>
                        : null
                      }

                      {
                        this.state.valueFilter === 'events' ?
                          <>
                            <p className="block-title">Tipo do Evento:</p>
                            <input type="hidden" id="trigger-parentCategory" name="trigger-parentCategory" value={this.state.eventParentCategory}/>
                            <Select
                              options={this.state.eventAvailableParentCategories}
                              className="basic-select"
                              classNamePrefix="select"
                              placeholder="Selecione o valor"
                              onChange={(e) => this.handleEventParentCategorySelect(e, false)}
                              isDisabled={this.state.viewMode}
                            />
                            
                            {
                              this.state.eventAvailableKeys && this.state.eventAvailableKeys.length !== 0 ? <><br/>
                                <p className="block-title">Chave do Evento:</p>
                                <input type="hidden" id="trigger-key" name="trigger-key" value={this.state.eventKey}/>
                                <Select
                                  options={this.state.eventAvailableKeys}
                                  className="basic-select"
                                  classNamePrefix="select"
                                  placeholder="Selecione o valor"
                                  onChange={this.handleEventKeySelect}
                                  isDisabled={this.state.viewMode}
                                /></>
                              : null
                            }

                            {
                              this.state.eventAvailableValues && this.state.eventAvailableValues.length !== 0 ? <><br/>
                                <p className="block-title">Comparador lógico:</p>
                                <input type="hidden" id="trigger-comparation" name="trigger-comparation" value={this.state.eventComparation}/>
                                <Select
                                  options={[
                                    {label: "Contém", value: "contain"},
                                    {label: "Não contém", value: "notcontain"}
                                  ]}
                                  className="basic-select"
                                  classNamePrefix="select"
                                  placeholder="Selecione o valor"
                                  onChange={this.handleEventComparationChange}
                                  isDisabled={this.state.viewMode}
                                /><br/>

                                <p className="block-title">Valor do Evento:</p>
                                <input type="hidden" id="trigger-value" name="trigger-value" value={JSON.stringify(this.state.eventValues)}/>
                                <Select
                                  options={this.state.eventAvailableValues}
                                  className="basic-select"
                                  classNamePrefix="select"
                                  placeholder="Selecione o valor"
                                  onChange={this.handleEventValueSelect}
                                  isDisabled={this.state.viewMode}
                                  isMulti
                                /></>
                              : null
                            }
                          </>
                        : null
                      }

                      {
                        this.state.valueFilter !== "abandon" && this.state.valueFilter !== "events" ?
                          <>
                            <p className="block-title">Filtrar por:</p>
                            <div className="select-group">
                              <select name="trigger-comparation" id="trigger-comparation" className="form-control" value={this.state.valueComparation} onChange={this.handleChangeComparation} required disabled={this.props.viewMode}>
                                <option value="==">Igual a</option>
                                <option value="!=">Diferente de</option>
                                <option value="contain">Contém</option>
                                <option value="notcontain">Não contém</option>
                              </select>
                            </div>
                            <input type="text" name="trigger-value" id="trigger-value" className="form-control" value={this.state.value} onChange={this.handleChangeValue} placeholder="Valor" required readOnly={this.props.viewMode}/>
                          </>
                        : null
                      }
                    </span>

                : <RecurrenceComponent cardData={this.props.cardData} changedTrigger={this.state.changedTrigger} viewMode={this.props.viewMode} />
              }

              <span>
                <p className="block-title" style={{marginTop: '15px'}}>Intervalo de notificação:</p>
                <input type="hidden" value={this.state.dischargeIn} name="trigger-dischargeIn" id="trigger-dischargeIn"/>
                <CreatableSelect
                  components={{DropdownIndicator: null}}
                  inputValue={this.state.dischargeInValue}
                  isClearable
                  isMulti
                  menuIsOpen={false}
                  onChange={this.handleChangeDischarge}
                  onInputChange={this.handleInputChange}
                  onKeyDown={this.handleKeyDown}
                  onBlur={this.handleKeyDown}
                  isDisabled={this.props.viewMode}
                  placeholder="Ex.: 1D 4h 30m (1 dia, 4 horas e 30 minutos)"
                  value={this.state.dischargeInArray}
                />
                <label htmlFor="trigger-dischargeIn" style={{color: "#fff", fontSize: "0.8rem", marginTop: "10px"}}>Obs: O numeral deve ser seguido por uma das letras a seguir: A (ano), M (mês), D (dia), h (hora), m (minuto) e s (segundo).</label>
              </span>
            </div>
          : null
        }
      </div>
    )
  }
}

class RecurrenceComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      trigger_comparation: '0',
      month_day: null,
      month_day_formatted: '',
      hours: null,
      hours_formatted: '',
      trigger_value: '0'
    }

    this.handleChange = this.handleChange.bind(this);
    this.createDays = this.createDays.bind(this);
    this.createHours = this.createHours.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleChangeHours = this.handleChangeHours.bind(this);
    this.handleChangeTrigger = this.handleChangeTrigger.bind(this);
  }

  componentDidMount() {
    const cardData = this.props.cardData;

    if (cardData && !this.props.changedTrigger) {
      const convertedHour = moment(cardData.values[0].hours, 'HH:mm:ss');
      const convertedMonth = moment(cardData.values[0].value)._d;

      this.setState({
        trigger_comparation: cardData.values[0].comparation,
        hours: moment(convertedHour).utc()._d,
        hours_formatted: cardData.values[0].hours,
        trigger_value: cardData.values[0].value,
        month_day_formatted: cardData.values[0].value,
        month_day: convertedMonth
      });
    }

    if (this.props.viewMode) return this.setState({viewMode: true});
  }

  handleChangeTrigger(e) {
    this.setState({
      trigger_comparation: e.target.value,
      hours: '',
      hours_formatted: '',
      trigger_value: '0',
      month_day_formatted: '',
      month_day: ''
    });
  }
  
  handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    let replaced = name.replace('-', '_');

    this.setState({[replaced]: value});
  }

  createDays() {
    let options = [];

    for ( let i = 1; i <= 31; i++ ) {
      options.push(<option key={i} value={i}>{i}</option>);
    }

    return options;
  }

  createHours() {
    let to = new Date();
    let from = new Date();
    let availableHours = [];

    from.setTime(from.getTime() - (23 * 60 * 60 * 1000));

    while ( to >= from ) {
      let withoutMinutes = ("00" + to.getHours()).slice(-2) + ":" + "00";
      let withMinutes = ("00" + to.getHours()).slice(-2) + ":" + "30";

      availableHours.push(<option key={withoutMinutes} value={withoutMinutes}>{withoutMinutes}</option>);
      availableHours.push(<option key={withMinutes} value={withMinutes}>{withMinutes}</option>);
      to.setTime(to.getTime() - (1 * 60 * 60 * 1000));
    }

    return availableHours;
  }

  handleDateChange(e) {
    this.setState({
      month_day: e,
      month_day_formatted: moment(e).format('MM-DD')
    });
  }

  handleChangeHours(e) {
    this.setState({
      hours: e,
      hours_formatted: moment(e).format('HH:mm')
    });
  }


  render() {
    return (
      <span key="recurrence">
        <div className="select-wrapper">
          <p className="block-title">Período da Recorrência:</p>
          <div className="select-group">
            <select name="trigger-comparation" id="trigger-comparation" value={this.state.trigger_comparation} className="form-control" onChange={this.handleChangeTrigger} disabled={this.state.viewMode}>
              <option value="0" disabled>Selecione uma opção</option>
              <option value="monthly">Mensal</option>
              <option value="weekly">Semanal</option>
              <option value="daily">Diário</option>
            </select>
          </div>
        </div>

        {
          this.state.trigger_comparation === 'monthly' ?
            <div className="select-wrapper" style={{marginTop: '25px'}}>
              <p className="block-title">Recorrência:</p>

              <input type="hidden" id="trigger-value" name="trigger-value" value={this.state.month_day_formatted}/>
              <DatePicker
                className="form-control"
                locale="pt-BR"
                selected={this.state.month_day}
                onChange={this.handleDateChange}
                timeInputLabel="Horário"
                dateFormat="dd/MM"
                placeholderText="Mês e dia"
                selectsStart
                popperPlacement="bottom"
                disabled={this.props.viewMode}
                popperModifiers={{
                  flip: {behavior: ["bottom"]},
                  offset: {enabled: true, offset: '20px, 5px'},
                  preventOverflow: {enabled: false},
                  hide: {enabled: false}
                }}
              />

              <input type="hidden" id="trigger-hours" name="trigger-hours" value={this.state.hours_formatted}/>
              <DatePicker
                className="form-control"
                locale="pt-BR"
                selected={this.state.hours}
                onChange={this.handleChangeHours}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                placeholderText="Hora e minuto"
                dateFormat="HH:mm"
                timeCaption="Horário"
                popperPlacement="bottom"
                disabled={this.props.viewMode}
                popperModifiers={{
                  flip: {behavior: ["bottom"]},
                  offset: {enabled: true, offset: '20px, 5px'},
                  preventOverflow: {enabled: false},
                  hide: {enabled: false}
                }}
              />
            </div>
          : ""
        }

        {
          this.state.trigger_comparation === 'weekly' ?
          <span key="recurrence">
            <div className="select-wrapper" style={{marginTop: '25px'}}>
              <p className="block-title">Recorrência:</p>
              <div className="select-group">
                <select name="trigger-value" id="trigger-value" value={this.state.trigger_value} className="form-control" onChange={this.handleChange} disabled={this.props.viewMode}>
                  <option value="0" disabled>Selecione o dia da semana</option>
                  <option value="monday">Segunda-feira</option>
                  <option value="tuesday">Terça-feira</option>
                  <option value="wednesday">Quarta-feira</option>
                  <option value="thursday">Quinta-feira</option>
                  <option value="friday">Sexta-feira</option>
                  <option value="saturday">Sábado</option>
                  <option value="sunday">Domingo</option>
                </select>
              </div>
            </div>
            
            <input type="hidden" id="trigger-hours" name="trigger-hours" value={this.state.hours_formatted}/>
            <DatePicker
              className="form-control"
              locale="pt-BR"
              selected={this.state.hours}
              onChange={this.handleChangeHours}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              placeholderText="Hora e minuto"
              dateFormat="HH:mm"
              timeCaption="Horário"
              popperPlacement="bottom"
              disabled={this.props.viewMode}
              popperModifiers={{
                flip: {behavior: ["bottom"]},
                offset: {enabled: true, offset: '20px, 5px'},
                preventOverflow: {enabled: false},
                hide: {enabled: false}
              }}
            />
          </span>
          : ''
        }

        {
          this.state.trigger_comparation === 'daily' ?
          <span key="recurrence">
            <div className="select-wrapper" style={{marginTop: '25px'}}>
              <p className="block-title">Recorrência:</p>
            </div>
            <input type="hidden" id="trigger-value" name="trigger-value" value=""/>
            <input type="hidden" id="trigger-hours" name="trigger-hours" value={this.state.hours_formatted}/>
            <DatePicker
              className="form-control"
              locale="pt-BR"
              selected={this.state.hours}
              onChange={this.handleChangeHours}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              placeholderText="Hora e minuto"
              dateFormat="HH:mm"
              timeCaption="Horário"
              popperPlacement="bottom"
              disabled={this.props.viewMode}
              popperModifiers={{
                flip: {behavior: ["bottom"]},
                offset: {enabled: true, offset: '20px, 5px'},
                preventOverflow: {enabled: false},
                hide: {enabled: false}
              }}
            />
          </span>
          : ''
        }
      </span>
    )
  }
}

export { TriggerBlock as Trigger };